import Parse from "parse";

const getUserWallets = async (email: string) => {
  try {
    const result = await Parse.Cloud.run("getUserWallets", { email });
    return result.wallets;
  } catch (error) {
    console.error("Error getting user wallets:", error);
    throw error;
  }
};

const fetchAndStoreSecondaryWallet = async (email: string) => {
  try {
    const result = await Parse.Cloud.run("fetchAndStoreSecondaryWallet", { email });
    return result;
  } catch (error) {
    console.error("Error fetching secondary wallet:", error);
    throw error;
  }
};

const getIdentityByEmail = async (email: string) => {
  try {
    const response = await Parse.Cloud.run("getIdentityAddressByEmail", { email });
    return response || null;
  } catch (error: any) {
    console.error(`Failed to get identity by email: ${error.message}`);
    return null;
  }
};

const saveUserWallet = async (email: string, walletData: any) => {
  try {
    const result = await Parse.Cloud.run("saveUserWallet", {
      email,
      ...walletData,
    });
    return result;
  } catch (error) {
    console.error("Error saving wallet:", error);
    throw error;
  }
};

// Deletes a UserWallets row directly. Only valid for wallets that were
// never linked on-chain
const deleteUserWallet = async (id: string) => {
  try {
    const result = await Parse.Cloud.run("deleteUserWallet", { id });
    return result;
  } catch (error) {
    console.error("Error deleting wallet:", error);
    throw error;
  }
};

// Sends the "Identity Approved" email.
const sendApprovalEmail = async (email: string) => {
  try {
    const result = await Parse.Cloud.run("sendApprovalEmail", { email });
    return result;
  } catch (error) {
    console.error("Error sending approval email:", error);
    throw error;
  }
};

// Returns the audit history of status changes (Denied / Under Review /
// Tester) for a single user, newest first. Pass userId or walletAddress.
const getUserStatusHistory = async (params: { userId?: string; walletAddress?: string; status?: string; page?: number; limit?: number }) => {
  try {
    const result = await Parse.Cloud.run("getUserStatusHistory", params);
    return result; // { data, pagination }
  } catch (error) {
    console.error("Error getting user status history:", error);
    throw error;
  }
};

// Returns the Persona-reset audit history for a single user, newest first.
// Pass userId or walletAddress.
const getPersonaResetHistory = async (params: { userId?: string; walletAddress?: string; page?: number; limit?: number }) => {
  try {
    const result = await Parse.Cloud.run("getPersonaResetHistory", params);
    return result; // { data, pagination }
  } catch (error) {
    console.error("Error getting persona reset history:", error);
    throw error;
  }
};

const UserService = {
  getUserWallets,
  fetchAndStoreSecondaryWallet,
  getIdentityByEmail,
  saveUserWallet,
  deleteUserWallet,
  sendApprovalEmail,
  getUserStatusHistory,
  getPersonaResetHistory,
};

export default UserService;
